module.exports = __webpack_public_path__ + "cement/media/技术合同登记.4787bd0f.mp4";